import { Injectable } from '@angular/core';
import { IFlightBriefCatering } from '@simplyfly/shared';
import { FirestoreService } from '../firestore/firestore.service';

@Injectable({
  providedIn: 'root'
})
export class FlightBriefCateringFirestoreService extends FirestoreService<IFlightBriefCatering> {
  protected basePath = 'flightBriefCaterings';
}
